import _ from 'lodash'
import numeral from 'numeral'
import { constants, utils as tkUtils } from '@adc/ui-core'

/**
 * TODO: this is a little odd having just this formatTitleCase imported from core, but was originally implemented
 * here and core and it became redundant. Using the core version here so we can still export it as part of btb toolkit,
 * but what we really should do is combine all the formatters from all toolkits and just put them in core.  Until such
 * time, this will prevent breaking all the places we import formatTitleCase from btb toolkit, while at the same
 * time leveraging the one version from core.
 */
const { formatTitleCase } = tkUtils.formatters

const { MODES: FILTER_MODES, MODE_OPTIONS: FILTER_MODE_OPTIONS } =
  constants.optionLists

const formatMoney = (val, defaultVal = '') => {
  if (_.isNil(val)) {
    return defaultVal
  } else {
    return numeral(val).format('$0,0')
  }
}

const formatMoneyWithCents = (val, defaultVal = '') => {
  if (_.isNil(val)) {
    return defaultVal
  } else {
    return numeral(val).format('$0,0.00')
  }
}

const formatNumber = (str = null, maximumFractionDigits = 0) =>
  str && !isNaN(str)
    ? str.toLocaleString('en-US', { maximumFractionDigits })
    : '0'

const formatPercentage = (
  val,
  maximumFractionDigits = 2,
  withSymbol = false
) => {
  const symbol = withSymbol ? '%' : ''
  return val ? _.round(val * 100.0, maximumFractionDigits) + symbol : val
}

const formatPhoneNumber = (phoneNumberString = '') => {
  const cleaned = String(phoneNumberString).replace(/\D/g, '')
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)

  return match
    ? '(' + match[1] + ') ' + match[2] + '-' + match[3]
    : phoneNumberString
}

const formatBool = (val, truthyVal = 'Yes', falsyVal = 'No') =>
  val ? truthyVal : falsyVal

const codesToText = (codes, optionList) => {
  if (!optionList) return codes
  return codes.map(code => {
    const option = _.find(optionList, { value: code })
    return option ? option.text : code
  })
}

const formatFilter = (filter, optionList) => {
  if (_.isEmpty(filter)) return ''

  if (!_.isEmpty(filter.is_equals)) {
    return (
      `${_.find(FILTER_MODE_OPTIONS, { value: FILTER_MODES.INCLUDE }).text}: ` +
      _.join(codesToText(filter.is_equals, optionList), ', ')
    )
  }
  if (!_.isEmpty(filter.is_not_equals)) {
    return (
      `${_.find(FILTER_MODE_OPTIONS, { value: FILTER_MODES.EXCLUDE }).text}: ` +
      _.join(codesToText(filter.is_not_equals, optionList), ', ')
    )
  }
  return `${_.find(FILTER_MODE_OPTIONS, { value: FILTER_MODES.ALL }).text}`
}

export {
  formatMoney,
  formatMoneyWithCents,
  formatNumber,
  formatPercentage,
  formatPhoneNumber,
  formatBool,
  formatTitleCase,
  formatFilter,
}
